import { getUrls } from '../constants';
import axios from 'axios';

export const getServerTime = () => {
  const url = getUrls('clock', 'refresh');
  return axios.get(url);
};
